import { buildSectionUrl, getSectionInnerHTML } from './utils';
import { Modal as PDPDialog } from '../../components/Modal';
import { Waitlist } from '../../components/Waitlist';
import { waitlistClickTracking } from '../../components/GTMEvents';
import { checkSoldOutItem } from '../../components/Waitlist/utils';

function getSectionToRender() {
  return {
    id: 'pdp-waitlist-modal',
    section: `pdp-${document.body.offsetWidth < 786 ? 'mobile-' : ''}waitlist`,
    selector: '.shopify-section',
  };
}

/**
 * Trigger's a waitlist modal on click event or direct function call
 * @param {event} e - Event object
 */
function waitlistClickHandle(e = undefined) {
  const sectionToRender = getSectionToRender();

  let waitlistBtn;
  if (e) {
    waitlistBtn = e.target;
    if (!waitlistBtn.classList.contains('pdp-c-atc__submit-btn--waitlist')) {
      return;
    }
  }

  const url = buildSectionUrl([sectionToRender]);

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Response error is not okay');
      }
      return response.json();
    })
    .then((data) => {
      const dialogObj = new PDPDialog(sectionToRender.id);
      dialogObj.setContent(getSectionInnerHTML(data[sectionToRender.section], sectionToRender.selector));

      if (waitlistBtn && waitlistBtn.closest('form')?.dataset.country !== 'US') {
        checkSoldOutItem(dialogObj.content);
      }

      // Open dialog modal
      dialogObj.show();

      // Defer this block because they are not user-visible tasks
      setTimeout(() => {
        const waitlistInstance = new Waitlist(dialogObj.node.querySelector('.pdp-c-waitlist__form'));
        waitlistInstance.init();

        if (waitlistBtn) {
          waitlistClickTracking(waitlistBtn.dataset.productTitle, waitlistBtn.dataset.productId);
        }

        dialogObj.setClose(() => {
          waitlistInstance.close();
        });
      }, 0);
    })
    .catch((error) => {
      console.error(error);
    });
}
/**
 * Checks URL param to trigger waitlist modal on page load
 */
function checkWaitListUrlParam() {
  if (window.location.hash === '#waitlist') {
    waitlistClickHandle();
  }
}

export { waitlistClickHandle, checkWaitListUrlParam };
